import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function() {
    if (document.body.classList.contains('wp-admin')) return setTimeout(() => mountSlide(), "3000"); //hacky thing to make it work in admin
    mountSlide();
} );


  function mountSlide() {
    if (document.querySelector('.hero-slider')) {
      const heroSlider = new Splide( '.hero-slider', {
        type: 'loop',
        pagination: false,
        easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
        autoplay: true,
        interval: 6000,
        gap: "50px"
    } );
    heroSlider.mount();
    }

    if (document.querySelector('.nav-slider')) { 
        const navSlider = new Splide( '.nav-slider', {
          autoWidth: true,
          clones: 0,
          type: 'loop',
          pagination: false,
          easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
          gap: "20px",
          padding: { right: '10rem' },
		  breakpoints: {
			640: {
				padding: { right: '0'},
			},
  }
      } );

      navSlider.mount();
      navSlider.on('active', function (slide) {
        const element = document.querySelector('.nav-slider')
        if (slide.index !== 0) element.style.setProperty('--opacity', '0px')
        if (slide.index === 0) element.style.setProperty('--opacity', '-50px')
        });
    }

    }

    
  

  
